const filters = {
  blur: 'saturate(200%) blur(30px)',
};

export default filters;
